<template>
  <q-table
    :rows="sortedRows"
    :columns="columns"
    :pagination="pagination"
  >
    <template #body-cell-actions="props">
      <q-td :props="props">
        <q-btn
          v-if="showDelete && !props.row.allowUnauthorizedScheduling"
          round
          flat
          dense
          icon="delete"
          color="negative"
          @click.stop="onDelete(props.row)"
        />
      </q-td>
    </template>
    <template
      v-for="(index, name) in $slots"
      #[name]="data"
    >
      <slot
        :name="name"
        v-bind="data"
      />
    </template>
  </q-table>
</template>
<script>

export default {
  name: 'TreatmentServicesTable',

  props: {
    rows: {
      type: Array,
      required: true,
    },
    rowsPerPage: {
      type: Number,
      default: null,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['delete'],

  data() {
    return {
      pagination: {
        rowsPerPage: this.rowsPerPage,
      },

    };
  },

  computed: {

    columns() {
      const actionColumns = [];
      if (this.showDelete) {
        actionColumns.push(
          {
            name: 'actions',
            align: 'right',
          },
        );
      }
      return [
        {
          name: 'serviceName',
          label: this.$t('settings.treatmentServices.serviceNameLabel'),
          field: 'serviceName',
          align: 'left',
          style: 'white-space: nowrap; width: 1px;', // fits content
          headerStyle: 'white-space: nowrap; width: 1px;',
        },
        {
          name: 'serviceCode',
          label: this.$t('settings.treatmentServices.serviceCodeLabel'),
          field: 'serviceCode',
          align: 'left',
        },
        ...actionColumns,
      ];
    },

    sortedRows() {
      const clientServices = this.rows.filter((row) => !row.allowUnauthorizedScheduling);
      const allowUnauthorizedServices = this.rows.filter((row) => row.allowUnauthorizedScheduling);

      const sortFn = (a, b) => {
        const aKey = `${a.serviceCode}|${a.serviceName}`;
        const bKey = `${b.serviceCode}|${b.serviceName}`;
        return aKey.localeCompare(bKey);
      };

      clientServices.sort(sortFn);
      allowUnauthorizedServices.sort(sortFn);

      return [...clientServices, ...allowUnauthorizedServices];
    },
  },

  methods: {
    onDelete(row) {
      this.$emit('delete', row);
    },
  },

};
</script>
